import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileBottomNav } from "./MobileBottomNav";
import { BetaBanner } from "./BetaBanner";
import { waLink } from "@/lib/constants";
import { MessageCircle, X, Heart, Headphones } from "lucide-react";
import { Toaster } from "sonner";

const WA_TEXT = "Salut Gabriel! Sunt pe TatiSiSofia.ro și aș vrea să vorbesc cu tine despre situația mea cu copilul meu. Îți mulțumesc!";

const FloatingActions = () => {
  const [open, setOpen] = useState(false);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="float-wa-wrap" data-testid="float-actions">
      {/* Menu panel */}
      {open && (
        <div
          data-testid="float-actions-menu"
          className="absolute bottom-16 right-0 w-64 space-y-2 animate-in fade-in slide-in-from-bottom-2 duration-150"
        >
          <Link
            to="/programare"
            data-testid="float-book"
            onClick={() => setOpen(false)}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-md bg-[#D4A63D] text-[#0A1020] text-xs font-bold tracking-wider shadow-[0_10px_30px_rgba(212,166,61,0.35)] hover:brightness-110 transition"
          >
            <Headphones className="w-4 h-4 shrink-0" />
            <span>VORBEȘTE CU GABRIEL</span>
          </Link>
          <Link
            to="/doneaza"
            data-testid="float-donate"
            onClick={() => setOpen(false)}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-md bg-[#E89BB8]/15 border border-[#E89BB8]/60 text-[#E89BB8] text-xs font-bold tracking-wider backdrop-blur-md hover:bg-[#E89BB8]/25 transition"
          >
            <Heart className="w-4 h-4 shrink-0 fill-[#E89BB8]" />
            <span>SUSȚINE</span>
          </Link>
          <a
            href={waLink(WA_TEXT)}
            target="_blank"
            rel="noreferrer"
            data-testid="float-whatsapp-msg"
            onClick={() => setOpen(false)}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-md bg-[#25D366] text-white text-xs font-bold tracking-wider shadow-[0_10px_30px_rgba(37,211,102,0.35)] hover:brightness-110 transition"
          >
            <MessageCircle className="w-4 h-4 shrink-0" />
            <span>SCRIE PE WHATSAPP</span>
          </a>
        </div>
      )}

      {/* Trigger button */}
      <button
        data-testid="float-whatsapp"
        aria-label={open ? "Închide meniul" : "Deschide meniul de contact"}
        onClick={() => setOpen((o) => !o)}
        className="float-wa"
      >
        {open ? <X className="w-7 h-7" /> : <MessageCircle className="w-7 h-7" />}
      </button>

      {/* Backdrop */}
      {open && (
        <button
          aria-hidden="true"
          tabIndex={-1}
          onClick={() => setOpen(false)}
          className="fixed inset-0 -z-10 bg-black/0"
        />
      )}
    </div>
  );
};

export const Layout = ({ children }) => (
  <div className="min-h-screen bg-[#0A1020] text-[#F8F8F4] has-bottom-nav">
    <Header />
    <main className="pt-20 md:pt-24">{children}</main>
    <Footer />
    <MobileBottomNav />
    <FloatingActions />
    <BetaBanner />
    <Toaster theme="dark" position="top-center" richColors />
  </div>
);
